import React from 'react';
import {
  Badge,
  Box,
  HStack,
  Skeleton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { RemoteQueryResult } from '../types';

interface Props {
  result: RemoteQueryResult | null;
  loading: boolean;
}

const SaktiRemoteDataGrid: React.FC<Props> = ({ result, loading }) => {
  if (loading) {
    return (
      <Box p={4}>
        <Skeleton height="20px" mb={2} />
        <Skeleton height="20px" mb={2} />
        <Skeleton height="20px" />
      </Box>
    );
  }

  if (!result) {
    return (
      <Box p={4} textAlign="center">
        <Text fontSize="sm" color="gray.400">Jalankan query untuk melihat hasil.</Text>
      </Box>
    );
  }

  const { columns, rows, rows_affected, duration_ms, is_write } = result;

  return (
    <Box>
      <HStack mb={2} spacing={3} flexWrap="wrap">
        <Badge colorScheme={is_write ? 'orange' : 'blue'} fontSize="0.7rem">
          {is_write ? 'WRITE' : 'READ'}
        </Badge>
        <Text fontSize="xs" color="gray.500">{rows_affected} baris</Text>
        <Text fontSize="xs" color="gray.500">{duration_ms}ms</Text>
      </HStack>

      {columns.length === 0 ? (
        <Text fontSize="sm" color="gray.500" p={2}>
          {is_write ? 'Operasi berhasil dieksekusi.' : 'Tidak ada data.'}
        </Text>
      ) : (
        <Box overflowX="auto" maxH="400px" overflowY="auto" borderWidth="1px" borderColor="gray.200" borderRadius="md">
          <Table size="sm" variant="simple" style={{ tableLayout: 'auto', minWidth: 'max-content' }}>
            <Thead bg="gray.50" position="sticky" top={0} zIndex={1}>
              <Tr>
                {columns.map((col) => (
                  <Th key={col} fontFamily="mono" fontSize="xs" whiteSpace="nowrap" py={2} px={3}>
                    {col}
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {rows.map((row, ri) => (
                <Tr key={ri} _hover={{ bg: 'gray.50' }}>
                  {(row as unknown[]).map((cell, ci) => (
                    <Td key={ci} fontFamily="mono" fontSize="xs" whiteSpace="nowrap" px={3}>
                      {cell === null ? (
                        <Text as="span" color="gray.400" fontStyle="italic">NULL</Text>
                      ) : (
                        String(cell)
                      )}
                    </Td>
                  ))}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  );
};

export default SaktiRemoteDataGrid;
